"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlag = void 0;

var _react = require("react");

var _Context = require("./Context");

const useFlag = flagKey => {
  const context = (0, _react.useContext)(_Context.FlagrContext); // fetch flag if it doesn't exist yet

  if (!context.flags[flagKey]) context.fetchFlag(flagKey);
  return context.flags[flagKey];
};

exports.useFlag = useFlag;